module.exports = __webpack_public_path__ + "d74058a4dc28555d0b59652bff2ddf32.svg";